import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IRecurringWorkflowSettingsFieldsFragment = {
  id?: any | null
  projectId: any
  frequency: any
  frequencyType: Types.CalendricalType
  endDate: any
  selectedDays?: Array<any | null> | null
}

export type IGetRecurringWorkflowSettingsByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ObjectId']['input']
}>

export type IGetRecurringWorkflowSettingsByIdQuery = {
  recurringWorkflowSettings?: {
    id?: any | null
    projectId: any
    frequency: any
    frequencyType: Types.CalendricalType
    endDate: any
    selectedDays?: Array<any | null> | null
  } | null
}

export type IListenToRecurringWorkflowSettingsSubscriptionVariables =
  Types.Exact<{
    projectId: Types.Scalars['ObjectId']['input']
  }>

export type IListenToRecurringWorkflowSettingsSubscription = {
  recurringWorkflowSettings?: {
    id?: any | null
    item?: {
      id?: any | null
      projectId: any
      frequency: any
      frequencyType: Types.CalendricalType
      endDate: any
      selectedDays?: Array<any | null> | null
    } | null
  } | null
}

export const RecurringWorkflowSettingsFieldsFragmentDoc = gql`
  fragment RecurringWorkflowSettingsFields on RecurringWorkflowSettings {
    id
    projectId
    frequency
    frequencyType
    endDate
    selectedDays
  }
`
export const GetRecurringWorkflowSettingsByIdDocument = gql`
  query GetRecurringWorkflowSettingsById($id: ObjectId!) {
    recurringWorkflowSettings(id: $id) {
      ...RecurringWorkflowSettingsFields
    }
  }
  ${RecurringWorkflowSettingsFieldsFragmentDoc}
`

/**
 * __useGetRecurringWorkflowSettingsByIdQuery__
 *
 * To run a query within a React component, call `useGetRecurringWorkflowSettingsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurringWorkflowSettingsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurringWorkflowSettingsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRecurringWorkflowSettingsByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetRecurringWorkflowSettingsByIdQuery,
    IGetRecurringWorkflowSettingsByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetRecurringWorkflowSettingsByIdQuery,
    IGetRecurringWorkflowSettingsByIdQueryVariables
  >(GetRecurringWorkflowSettingsByIdDocument, options)
}
export function useGetRecurringWorkflowSettingsByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetRecurringWorkflowSettingsByIdQuery,
    IGetRecurringWorkflowSettingsByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetRecurringWorkflowSettingsByIdQuery,
    IGetRecurringWorkflowSettingsByIdQueryVariables
  >(GetRecurringWorkflowSettingsByIdDocument, options)
}
export type GetRecurringWorkflowSettingsByIdQueryHookResult = ReturnType<
  typeof useGetRecurringWorkflowSettingsByIdQuery
>
export type GetRecurringWorkflowSettingsByIdLazyQueryHookResult = ReturnType<
  typeof useGetRecurringWorkflowSettingsByIdLazyQuery
>
export type GetRecurringWorkflowSettingsByIdQueryResult = Apollo.QueryResult<
  IGetRecurringWorkflowSettingsByIdQuery,
  IGetRecurringWorkflowSettingsByIdQueryVariables
>
export const ListenToRecurringWorkflowSettingsDocument = gql`
  subscription ListenToRecurringWorkflowSettings($projectId: ObjectId!) {
    recurringWorkflowSettings(projectId: $projectId) {
      id
      item {
        ...RecurringWorkflowSettingsFields
      }
    }
  }
  ${RecurringWorkflowSettingsFieldsFragmentDoc}
`

/**
 * __useListenToRecurringWorkflowSettingsSubscription__
 *
 * To run a query within a React component, call `useListenToRecurringWorkflowSettingsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenToRecurringWorkflowSettingsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenToRecurringWorkflowSettingsSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListenToRecurringWorkflowSettingsSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenToRecurringWorkflowSettingsSubscription,
    IListenToRecurringWorkflowSettingsSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenToRecurringWorkflowSettingsSubscription,
    IListenToRecurringWorkflowSettingsSubscriptionVariables
  >(ListenToRecurringWorkflowSettingsDocument, options)
}
export type ListenToRecurringWorkflowSettingsSubscriptionHookResult =
  ReturnType<typeof useListenToRecurringWorkflowSettingsSubscription>
export type ListenToRecurringWorkflowSettingsSubscriptionResult =
  Apollo.SubscriptionResult<IListenToRecurringWorkflowSettingsSubscription>
